import { referralsLoading, referralsLoaded, referralsLoadFailed } from "../../../actions/dashboardActions";

// Loads the estate agent Referrals tab. A failure is shown on the tab rather than bouncing the
// agent to /login: the dashboard itself has already loaded, so the session is known to be good.
export function loadReferralsData(dispatch, signal) {
  dispatch(referralsLoading());
  return fetch("/api/dashboard/referrals", { method: "GET", credentials: "same-origin", signal })
    .then((resp) => {
      if (!resp.ok) {
        throw new Error(`Referrals request failed with status ${resp.status}`);
      }
      return resp.json();
    })
    .then((resp) => {
      if (resp.error) {
        throw new Error(resp.error);
      }
      dispatch(referralsLoaded(resp));
    })
    .catch((err) => {
      if (err.name === "AbortError") return;
      console.error("Failed to load referrals data", err);
      dispatch(referralsLoadFailed());
    });
}
